import React from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const StyledTabs = withStyles({
  root: {
    // borderBottom: "1px solid #e8e8e8",
    backgroundColor: "white",
    // marginBottom: 40,
  },
})(Tabs);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    width: "fit-content !important",
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    fontSize: 14,
    // backgroundColor: "transparent",

    color: "#1e1e1e",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    backgroundColor: "rgba(7,127,131,.75)",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    "&:hover,&.Mui-selected": {

      color: "#fff",
      backgroundColor: "rgba(7,127,131,1)",
      opacity: 1
    }
    // "&:hover": {
    //   color: "#40a9ff",
    //   opacity: 1,
    // },
    // "&$selected": {
    //   color: "#1890ff",
    //   fontWeight: theme.typography.fontWeightMedium,
    // },
    // "&:focus": {
    //   color: "#40a9ff",
    // },
  },
  selected: {},
  textColorInherit: { color: "#232323" },
}))((props) => <Tab disableRipple {...props} />);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} mt="40px">
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    width: "100%",
    "& header": {
      background: "white",
    },
  },
}));

/**
 * @props
 ** tabNames --- An Array of strings,
 ** tabContent --- it must be an array of react components with hardcoded key.
 *
 * @description the tab names array and components array order matters
 * The component on the 0 index in the components array is for the tab that is on the 0
 *  index in the tabNames array too.
 *
 * @example tabNames = ['first name', 'second name']
    componets = [<ThisCmpIsForFirstName key={0} />, <ThisCmpIsForSecondName key={1} />]
 */
export default function CustomTab(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const { tabNames, tabContent } = props;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          style={{ marginLeft: '5.5rem' }}
          // centered
          TabIndicatorProps={{ style: { background: 'rgba(7,127,131,1)' } }}
        >
          {tabNames?.map((name, i) => (
            <StyledTab
              style={{ width: "88px" }}
              key={i}
              label={name}
              {...a11yProps(i)}
            />
          ))}
        </StyledTabs>
      </AppBar>
      {tabContent?.map((item, i) => (
        <TabPanel key={i} value={value} index={i}>
          {item}
        </TabPanel>
      ))}
    </div>
  );
}
